import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

import { FsLprCamerasService } from '../../api/';

@Component({
  selector: 'fs-lpr-query-camera-form',
  templateUrl: './lpr-query-camera-form.component.html',
  styleUrls: ['./lpr-query-camera-form.component.scss'],
})
export class LprQueryCameraFormComponent implements OnDestroy, OnInit {
  public readonly form = new UntypedFormGroup({});
  public readonly formModel: any = {};
  public readonly formFields: SnFormFieldConfig[] = [
    {
      key: 'name',
      type: 'input',
      defaultValue: this.camera.properties?.name || this.camera.name,
      templateOptions: {
        label: t('vehicleIntelligence.cameraName'),
        required: true,
        floatLabel: 'always',
      },
    },
    {
      key: 'heading',
      type: 'radial',
      defaultValue: this.camera.properties?.heading || this.camera.heading,
      templateOptions: {
        label: t('vehicleIntelligence.heading'),
        required: true,
        floatLabel: 'always',
        change: (field) => {
          this.formModel.heading = field.formControl.value;
        },
      },
    },
  ];

  private readonly _destroy$ = new Subject<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public camera: any,
    private readonly _matDialogRef: MatDialogRef<LprQueryCameraFormComponent>,
    private readonly _lprCamerasService: FsLprCamerasService,
    private readonly _toastrService: ToastrService,
  ) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submit(): void {
    const data: {
      name: string;
      heading: number;
      latitude?: number;
      longitude?: number;
    } = {
      name: this.formModel.name,
      heading: this.formModel.heading,
    };
    if (this.camera.geometry) {
      data.latitude = this.camera.geometry.coordinates[1];
      data.longitude = this.camera.geometry.coordinates[0];
    }
    // Camera data coming from the map is in the properties object, but camera data coming from the list is in the camera object
    const provider =
      this.camera.properties?.provider.toUpperCase() || this.camera.provider.toUpperCase();
    const id = this.camera.properties?.id || this.camera.id;
    if (!provider || !id) {
      return;
    }
    this._lprCamerasService
      .updateCameras(provider, id, data)
      .pipe(takeUntil(this._destroy$))
      .subscribe((res) => {
        if (res) {
          this._toastrService.success(t('vehicleIntelligence.cameraUpdated'));
          this._matDialogRef.close(res);
        }
      });
  }

  public cancel(): void {
    this._matDialogRef.close();
  }
}
